<!-- Copyright (c) 2024 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="haulageCharges-main">
    <Menus :menu="menus" @menuClicked="handleMenuClicked" />

    <PopupEntry
      v-if="popupEntryShow"
      :show.sync="popupEntryShow"
      :title.sync="popupEntryTitle"
      :requiredError.sync="requiredErrors"
      :errorMessages.sync="errorMessages"
      @save="saveClicked"
      @requiredClicked="errorMessageClicked"
      :viewMode="viewMode"
      :updatedBy="updatedBy"
      :createdBy="createdBy"
      :successMessages="successMessages"
    >
      <div style="height: 100%; overflow-y: auto">
        <div style="display: flex; justify-content: space-between">
          <InputQuery
            class="input-query-width"
            placeholder="Charge Code"
            :isRequired="true"
            :items="chargeCodeListMaster"
            itemKey="Charge Code - Description"
            descKey="Description"
            :selectedObject.sync="selectedChargeCode"
            :search.sync="chargeCodeSearch"
            :errorMessage.sync="chargeCodeError"
            ref="chargeCode"
            :isDisabled="viewMode || disableWhenEdit"
            @selected="haulageRateB2BCoefCheck"
          />
          <DateTimePicker
            placeholder="Valid From"
            :isRequired="true"
            style="margin-right: 30px"
            ref="validFrom"
            :value.sync="validFromDate"
            :errorMessage.sync="validFromDateError"
            :isDisabled="viewMode"
          />
        </div>

        <InputQuery
          class="input-query-width"
          placeholder="Billing Customer Code"
          :items="billingCustomerCodeListMaster"
          itemKey="Customer Code - Customer Name"
          descKey="Customer Name"
          :selectedObject.sync="selectedCustomerCode"
          :search.sync="customerCodeSearch"
          :errorMessage.sync="customerCodeError"
          ref="billingCustomerCode"
          :isDisabled="viewMode"
        />
        <InputQuery
          class="input-query-width"
          placeholder="Customer (shipper/consignee)"
          :items="shipperConsigneeListMaster"
          itemKey="Customer Code - Customer Name"
          descKey="Customer Name"
          :selectedObject.sync="selectedShipperConsingnee"
          :search.sync="shipperConsigneeSearch"
          :errorMessage.sync="shipperConsigneeError"
          ref="shipperConsignee"
          :isDisabled="viewMode"
        />
        <RadioButtonSet
          title=""
          :buttons="buttonSet1"
          labelKey="label"
          style="width: 300px; margin-bottom: 8px"
          :isHorizontal="true"
          :selected.sync="selectedTariffCode"
          :isDisabled="viewMode || disableWhenEdit"
        />
        <InputQuery
          v-if="selectedTariffCode.label === 'Tariff Area'"
          class="input-query-width"
          placeholder=" Tariff Area"
          :items="tariffAreaListMaster"
          itemKey="Area Code - Description"
          descKey="Description"
          :selectedObject.sync="selectedTariffAreaCode"
          :search.sync="tariffAreaCodeSearch"
          :errorMessage.sync="tariffAreaCodeError"
          ref="tariffArea"
          :isDisabled="viewMode"
          style="margin-bottom: 8px"
        />
        <TableBox
          v-if="selectedTariffCode.label === 'Zone Category'"
          title="Zone Category"
          :tableData="zoneCategoryListMaster"
          :maxSelection="-1"
          :selectedRow.sync="selectedZoneCategories"
          :loading.sync="tableBoxLoading"
          style="height: 500px; margin-bottom: 8px"
        />
        <InputQuery
          v-if="showRef"
          class="input-query-width"
          :placeholder="refTitle"
          :items="refList"
          itemKey="code - desc"
          :isRequired="compRefVal"
          :selectedObject.sync="selectedRef"
          :errorMessage.sync="refTypeError"
          ref="refType"
          :isDisabled="viewMode"
        />
        <div style="display: flex; align-items: center; margin-top: 10px">
          <InputQuery
            class="input-query-width"
            placeholder="Rate Type"
            :items="rateTypes"
            itemKey="unit"
            descKey="description"
            :isRequired="true"
            :selectedObject.sync="selectedRateType"
            :errorMessage.sync="rateTypeError"
            :allowFreeText="false"
            ref="rateType"
            :isDisabled="viewMode"
          />
          <InputQuery
            class="input-query-width"
            placeholder="Job Type"
            :items="jobTypeListMaster"
            itemKey="Job Type - Description"
            descKey="JobTypeDesc"
            :selectedObject.sync="selectedJobType"
            :search.sync="jobTypeSearch"
            :errorMessage.sync="jobTypeError"
            ref="jobType"
            :isDisabled="viewMode"
          />
        </div>

        <div v-if="displayRate">
          <Input
            placeholder="Rate for 20'"
            :isRequired="true"
            style="width: 40%"
            validator="positiveDecimal,14,4"
            :inputValue.sync="rateFor20"
            :errorMessage.sync="rateFor20Error"
            ref="rateFor20"
            :isDisabled="viewMode"
          />
          <Input
            placeholder="Rate for 40'"
            :isRequired="true"
            style="width: 40%"
            validator="positiveDecimal,14,4"
            :inputValue.sync="rateFor40"
            :errorMessage.sync="rateFor40Error"
            ref="rateFor40"
            :isDisabled="viewMode"
          />
        </div>
        <div v-if="displayPercentage">
          <div class="displayPercentage">
            <Input
              placeholder="Percentage for 20'"
              :isRequired="true"
              :inputValue.sync="percentageFor20"
              validator="positiveDecimal,14,4"
              :errorMessage.sync="percentageFor20Error"
              ref="percentageFor20"
              :isDisabled="viewMode"
            />
            <p>% of Rate for</p>
            <InputQuery
              style="justify-items: start"
              placeholder="Container"
              :isRequired="true"
              :items="containers"
              itemKey="container"
              :selectedObject.sync="container1"
              :search.sync="container1Search"
              :errorMessage.sync="container1Error"
              ref="container1"
              :isDisabled="viewMode"
            />
            <Input
              placeholder="Percentage for 40'"
              :isRequired="true"
              :inputValue.sync="percentageFor40"
              validator="positiveDecimal,14,4"
              :errorMessage.sync="percentageFor40Error"
              ref="percentageFor40"
              :isDisabled="viewMode"
            />
            <p>% of Rate for</p>
            <InputQuery
              placeholder="Container"
              :isRequired="true"
              :items="containers"
              itemKey="container"
              :selectedObject.sync="container2"
              :search.sync="container2Search"
              :errorMessage.sync="container2Error"
              ref="container2"
              :isDisabled="viewMode"
            />
          </div>
        </div>
        <div v-if="showB2BCoef" class="B2BCoefficient">
          <RadioButtonSet
            style="width: 320px; padding-right: 20px"
            title="B2B Coefficient (for 20' only)"
            :buttons="buttonSet2"
            labelKey="label"
            :isHorizontal="true"
            :selected.sync="selectedB2BCoefficient"
            :isDisabled="viewMode"
          />
          <Input
            style="width: 200px"
            :placeholder="b2bTitle"
            :isDisabled="disableB2BCoefficient || viewMode"
            :inputValue.sync="b2bCoefficient"
            validator="positiveDecimal,14,6"
            :errorMessage.sync="b2bCoefficientError"
            ref="specialB2BCoefficient"
          />
        </div>

        <InputQuery
          class="input-query-width"
          placeholder="Mark Up Rate Type"
          :items="rateTypes"
          itemKey="unit"
          descKey="description"
          :isRequired="true"
          :selectedObject.sync="selectedMarkupRateType"
          style="margin-top: 20px"
          :allowFreeText="false"
          :errorMessage.sync="markupRateTypeError"
          ref="markupRateType"
          :isDisabled="viewMode"
        />
        <div v-if="displayMarkupRate">
          <Input
            placeholder="Rate for 20'"
            :isRequired="true"
            style="width: 40%"
            :inputValue.sync="markupRateFor20"
            validator="positiveDecimal,14,4"
            :errorMessage.sync="markupRateFor20Error"
            ref="markupRateFor20"
            :isDisabled="viewMode"
          />
          <Input
            placeholder="Rate for 40'"
            :isRequired="true"
            style="width: 40%"
            :inputValue.sync="markupRateFor40"
            validator="positiveDecimal,14,4"
            :errorMessage.sync="markupRateFor40Error"
            ref="markupRateFor40"
            :isDisabled="viewMode"
          />
        </div>
        <div v-if="displayMarkupPercentage">
          <div class="displayPercentage">
            <Input
              placeholder="Percentage for 20'"
              :isRequired="true"
              :inputValue.sync="markupPercentageFor20"
              validator="positiveDecimal,14,4"
              :errorMessage.sync="markupPercentageFor20Error"
              ref="markupPercentageFor20"
              :isDisabled="viewMode"
            />
            <p>% of Rate for</p>
            <InputQuery
              style="justify-items: start"
              placeholder="Container"
              :isRequired="true"
              :items="containers"
              itemKey="container"
              :selectedObject.sync="container3"
              :search.sync="container3Search"
              :errorMessage.sync="container3Error"
              ref="container3"
              :isDisabled="viewMode"
            />
            <Input
              placeholder="Percentage for 40'"
              :isRequired="true"
              :inputValue.sync="markupPercentageFor40"
              validator="positiveDecimal,14,4"
              :errorMessage.sync="markupPercentageFor40Error"
              ref="markupPercentageFor40"
              :isDisabled="viewMode"
            />
            <p>% of Rate for</p>
            <InputQuery
              placeholder="Container"
              :isRequired="true"
              :items="containers"
              itemKey="container"
              :selectedObject.sync="container4"
              :search.sync="container4Search"
              :errorMessage.sync="container4Error"
              ref="container4"
              :isDisabled="viewMode"
            />
          </div>
        </div>
      </div>
    </PopupEntry>

    <div class="rightContainer">
      <div class="bottomSection">
        <TableBox
          title="Haulage Rates"
          :tableData.sync="haulageChargesList"
          :selectedRow.sync="selectedHaulageCharges"
          :loading.sync="tableBoxLoading"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    b2bCoef() {
      if (this.selectedB2BCoefficient && this.selectedB2BCoefficient.label === 'Special') {
        return {
          disable: false,
          title: 'Special B2B Coefficient',
        };
      }

      return {
        disable: true,
        title: 'Standard B2B Coefficient',
      };
    },
    disableB2BCoefficient() {
      return this.b2bCoef.disable;
    },
    b2bTitle() {
      return this.b2bCoef.title;
    },
  },
  data: function () {
    return {
      menus: [
        {
          title: 'New Haulage Rates',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          key: 'MnuNew',
          visible: true,
          enabled: false,
        },
        {
          title: 'Edit Haulage Rates',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png',
          key: 'MnuEdit',
          visible: true,
          enabled: false,
        },
        {
          title: 'Delete Haulage Rates',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          key: 'MnuDelete',
          visible: true,
          enabled: false,
        },
        {
          title: 'View Haulage Rates',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png',
          key: 'MnuQuery',
          visible: true,
          enabled: false,
        },
      ],
      // Pop Up Box Setting
      popupEntryShow: false,
      popupEntryTitle: '',
      requiredErrors: [],
      errorMessages: [],
      successMessages: [],
      selectedHaulageCharges: [],
      tableBoxLoading: false,
      viewMode: false,

      // Rate Settings
      displayRate: true,
      displayPercentage: false,
      displayMarkupRate: true,
      displayMarkupPercentage: false,

      // Pop Up Box Input Fields
      // Start
      createdBy: '',
      updatedBy: '',
      seqno: '',
      validFromDate: null,
      selectedChargeCode: null,
      chargeCodeSearch: '',
      selectedCustomerCode: null,
      customerCodeSearch: '',
      selectedShipperConsingnee: null,
      shipperConsigneeSearch: '',
      selectedTariffAreaCode: null,
      tariffAreaCodeSearch: '',
      selectedZoneCategories: [],
      selectedRef: null,

      selectedJobType: null,
      jobTypeSearch: '',

      // Non mark up rates
      rateFor20: '',
      rateFor40: '',
      b2bCoefficient: '',
      percentageFor20: '',
      percentageFor40: '',
      container1: null,
      container1Search: '',
      container2: null,
      container2Search: '',

      // Mark up rates
      markupRateFor20: '',
      markupRateFor40: '',
      markupPercentageFor20: '',
      markupPercentageFor40: '',
      container3: null,
      container3Search: '',
      container4: null,
      container4Search: '',

      // End
      // Pop Up Box Input Fields

      // Error Messages
      chargeCodeError: '',
      customerCodeError: '',
      shipperConsigneeError: '',
      tariffAreaCodeError: '',
      refTypeError: '',
      rateTypeError: '',
      jobTypeError: '',
      rateFor20Error: '',
      rateFor40Error: '',
      b2bCoefficientError: '',
      percentageFor20Error: '',
      container1Error: '',
      percentageFor40Error: '',
      container2Error: '',
      markupRateTypeError: '',
      markupRateFor20Error: '',
      markupRateFor40Error: '',
      container3Error: '',
      markupPercentageFor40Error: '',
      markupPercentageFor20Error: '',
      container4Error: '',
      validFromDateError: '',

      // Radio Buttons
      buttonSet1: [{ label: 'Tariff Area' }, { label: 'Zone Category' }],
      buttonSet2: [{ label: 'Use Standard' }, { label: 'Special' }],
      disableWhenEdit: false,

      // Rate types
      rateTypes: [
        { unit: '$', description: 'Rate' },
        { unit: '%', description: 'Percentage' },
      ],

      // Containers
      containers: [
        { container: "20' Container", value: '20' },
        { container: "40' Container", value: '40' },
      ],
      // Radio Types
      selectedRateType: null,
      selectedMarkupRateType: null,
      // selectedRadios
      selectedTariffCode: null,
      selectedB2BCoefficient: null,

      // disable input fields
      showB2BCoef: false,
      showRef: false,
      refTitle: '',
      refTable: '',
      refDesc: '',
      refList: [],
      compRefVal: false,

      // API calls data
      haulageChargesList: [],
      chargeCodeListMaster: [],
      billingCustomerCodeListMaster: [],
      shipperConsigneeListMaster: [],
      tariffAreaListMaster: [],
      zoneCategoryListMaster: [],
      jobTypeListMaster: [],
    };
  },
  methods: {
    // API call functions
    getSpecificHaulageCharges: async function (seqno, recordid) {
      const response = await this.$apiCallV2('/Master/GetDetailsMaster', {
        masterfile: 'OTHERCHARGES',
        recordid: recordid,
        seqno: seqno,
      });
      return response;
    },
    getChargeCodeListMaster: async function () {
      this.chargeCodeListMaster = [];
      const list = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CHARGESCODE' });
      this.chargeCodeListMaster = list.map((item) => ({
        ...item,
        'Charge Code - Description': `${item['Charge Code']} - ${item.Description}`,
      }));
    },
    getBillingCustomerCodeListMaster: async function () {
      this.billingCustomerCodeListMaster = [];
      const list = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CUSTOMER' });
      this.billingCustomerCodeListMaster = list.map((item) => ({
        ...item,
        'Customer Code - Customer Name': `${item['Customer Code']} - ${item['Customer Name']}`,
      }));
    },
    getShipperConsigneeListMaster: async function () {
      this.shipperConsigneeListMaster = [];
      const list = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SHIPPERCONSIGNEE' });
      this.shipperConsigneeListMaster = list.map((item) => ({
        ...item,
        'Customer Code - Customer Name': `${item['Customer Code']} - ${item['Customer Name']}`,
      }));
    },
    getTariffAreaListMaster: async function () {
      this.tariffAreaListMaster = [];
      const list = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'AREA' });
      this.tariffAreaListMaster = list.map((item) => ({
        ...item,
        'Area Code - Description': `${item['Area Code']} - ${item['Description']}`,
      }));
    },
    getZoneCategoryListMaster: async function () {
      this.zoneCategoryListMaster = [];
      this.zoneCategoryListMaster = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'ZONECategory' });
    },
    getJobType: async function () {
      this.jobTypeListMaster = [];
      const list = await this.$apiCallV2('/Master/GetListMaster', {
        masterfile: 'JobType',
        module: 'HMS',
      });
      this.jobTypeListMaster = list.map((item) => ({
        ...item,
        'Job Type - Description': `${item['Job Type']} - ${item['Description']}`,
      }));
    },
    getListing: async function () {
      this.haulageChargesList = [];
      this.tableBoxLoading = true;
      this.haulageChargesList = await this.$apiCallV2('/HaulageRate/GetOtherChargesListing');
      this.tableBoxLoading = false;
    },
    clearPopupEntryFields: function () {
      this.seqno = '';
      this.selectedChargeCode = null;
      this.chargeCodeSearch = '';
      this.validFromDate = null;
      this.selectedCustomerCode = null;
      this.customerCodeSearch = '';
      this.selectedShipperConsingnee = null;
      this.shipperConsigneeSearch = '';
      this.selectedTariffCode = this.buttonSet1.find(({ label }) => label === 'Tariff Area');
      this.selectedTariffAreaCode = null;
      this.tariffAreaCodeSearch = '';
      this.selectedZoneCategories = [];
      this.selectedRef = null;
      this.selectedRateType = this.rateTypes.find(({ unit }) => unit === '$');
      this.selectedJobType = null;
      this.jobTypeSearch = '';
      this.rateFor20 = '';
      this.rateFor40 = '';
      this.selectedB2BCoefficient = this.buttonSet2.find(({ label }) => label === 'Use Standard');
      this.b2bCoefficient = '';
      this.percentageFor20 = '';
      this.container1 = null;
      this.container1Search = '';
      this.percentageFor40 = '';
      this.container2 = null;
      this.container2Search = '';
      this.selectedMarkupRateType = this.rateTypes.find(({ unit }) => unit === '$');
      this.markupRateFor20 = '';
      this.markupRateFor40 = '';
      this.markupPercentageFor20 = '';
      this.container3 = null;
      this.container3Search = '';
      this.markupPercentageFor40 = '';
      this.container4 = null;
      this.container4Search = '';
      this.showB2BCoef = false;
      this.showRef = false;
      this.compRefVal = false;
      this.refTitle = '';
      this.updatedBy = '';
      this.displayRate = true;
      this.displayPercentage = false;
      this.displayMarkupRate = true;
      this.displayMarkupPercentage = false;
    },
    clearErrorMessages: function () {
      this.errorMessages = [];
      this.successMessages = [];
      this.chargeCodeError = '';
      this.customerCodeError = '';
      this.shipperConsigneeError = '';
      this.tariffAreaCodeError = '';
      this.refTypeError = '';
      this.rateTypeError = '';
      this.jobTypeError = '';
      this.rateFor20Error = '';
      this.rateFor40Error = '';
      this.b2bCoefficientError = '';
      this.percentageFor20Error = '';
      this.container1Error = '';
      this.percentageFor40Error = '';
      this.container2Error = '';
      this.markupRateTypeError = '';
      this.markupRateFor20Error = '';
      this.markupRateFor40Error = '';
      this.container3Error = '';
      this.markupPercentageFor40Error = '';
      this.markupPercentageFor20Error = '';
      this.container4Error = '';
      this.validFromDateError = '';
    },
    handleMenuClicked: async function (menu) {
      this.clearErrorMessages();
      this.clearPopupEntryFields();
      this.successMessages = [];
      this.requiredErrors = [];
      let haulageCharges = [];
      switch (menu.title) {
        case 'New Haulage Rates':
          this.popupEntryTitle = 'New Haulage Rates';
          this.popupEntryShow = true;
          this.viewMode = false;
          this.disableWhenEdit = false;
          break;
        case 'Edit Haulage Rates':
          if (this.selectedHaulageCharges.length === 0) {
            this.$showAlert('error', 'No Haulage Rates Selected', 'Please select a Haulage Rates to Edit');
            return;
          }
          this.viewMode = false;
          this.popupEntryTitle = 'Edit Haulage Rates';
          this.popupEntryShow = true;
          this.selectedTariffCode = { label: 'Tariff Area' };
          this.disableWhenEdit = true;
          haulageCharges = await this.getSpecificHaulageCharges(
            this.selectedHaulageCharges[0]['SeqNo'],
            this.selectedHaulageCharges[0]['ChargeCode'],
          );
          this.populatePopupEntry(haulageCharges.OtherCharges);
          break;
        case 'View Haulage Rates':
          if (this.selectedHaulageCharges.length == 0) {
            this.$showAlert('error', 'No Haulage Rates Selected', 'Please select a record to view');
            return;
          }
          this.disableWhenEdit = false;
          this.popupEntryTitle = 'View Haulage Rates';
          this.popupEntryShow = true;
          haulageCharges = await this.getSpecificHaulageCharges(
            this.selectedHaulageCharges[0]['SeqNo'],
            this.selectedHaulageCharges[0]['ChargeCode'],
          );
          this.populatePopupEntry(haulageCharges.OtherCharges);
          this.viewMode = true;
          break;
        case 'Delete Haulage Rates': {
          if (this.selectedHaulageCharges.length === 0) {
            this.$showAlert('error', 'No Haulage Rates Selected', 'Please select a Haulage Rates to Delete');
            return;
          }
          const deleting = await this.$showAlert(
            'warning',
            'Delete Haulage Rates',
            `Are you sure you want to delete Seq no : ${
              this.selectedHaulageCharges[0]['SeqNo']
            }  \n Haulage Rates Code  : ${this.selectedHaulageCharges[0]['ChargeCode']}?`,
            [
              { text: 'Delete', textColor: 'white', color: 'red' },
              { text: 'Cancel', textColor: 'black', color: 'lightgray' },
            ],
          );
          if (deleting == 'Cancel') {
            return;
          }
          this.$fullscreenLoading('Deleting Haulage ');
          const result = await this.$apiCallV2('/HaulageRate/UpdateRates', {
            action: 'D',
            chgcode: this.selectedHaulageCharges[0]['ChargeCode'],
            seqno: this.selectedHaulageCharges[0]['SeqNo'],
            system: 'HMS',
          });
          this.$fullscreenLoading();
          if (result[0]['Results'] == 0) {
            this.$showAlert(
              'success',
              'Haulage Code Deleted',
              `Successfully deleted Haulage Charge Code ${this.selectedHaulageCharges[0]['ChargeCode']}`,
            );
            this.$nextTick(async () => await this.getListing());
            return;
          }
          this.$showAlert(
            'error',
            'Haulage Charge Code NOT Deleted',
            `There was an error deleting Haulage Charge Code : ${this.selectedHaulageCharges[0]['ChargeCode']}`,
          );
          break;
        }
      }
    },
    populatePopupEntry: async function (selectedHaulageCharges) {
      // createdBy
      this.selectedChargeCode =
        selectedHaulageCharges.ChargeCode ?
          this.chargeCodeListMaster.getSelected(selectedHaulageCharges.ChargeCode, 'Charge Code')
        : null;

      if (this.selectedChargeCode) {
        await this.haulageRateB2BCoefCheck();
      }

      const zonecategories = selectedHaulageCharges['ZoneCategory']?.split(',') ?? [];
      this.selectedZoneCategories = this.zoneCategoryListMaster.filter((obj) =>
        zonecategories.includes(obj['Zone Category']),
      );

      this.updatedBy = `${selectedHaulageCharges['UserID'] || ''} ${
        selectedHaulageCharges['Last Update Time'] ?
          new Date(selectedHaulageCharges['Last Update Time']).formatString('yyyy-MM-dd HH:mm:ss')
        : ''
      }`;
      this.b2bCoefficient = selectedHaulageCharges['B2BCoeff'];
      this.selectedB2BCoefficient =
        selectedHaulageCharges['B2BCoeffType'] === '1' ? { label: 'Special' } : { label: 'Use Standard' };
      this.seqno = selectedHaulageCharges['SeqNo'];

      this.selectedCustomerCode =
        selectedHaulageCharges.BillingCustomerCode ?
          this.billingCustomerCodeListMaster.getSelected(selectedHaulageCharges.BillingCustomerCode, 'Customer Code')
        : null;
      this.selectedShipperConsingnee =
        selectedHaulageCharges['ShipperConsignee'] ?
          this.shipperConsigneeListMaster.getSelected(selectedHaulageCharges['ShipperConsignee'], 'Customer Code')
        : null;
      this.selectedTariffAreaCode =
        selectedHaulageCharges['TariffArea'] ?
          this.tariffAreaListMaster.getSelected(selectedHaulageCharges['TariffArea'], 'Area Code')
        : null;
      // zone category
      this.selectedJobType =
        selectedHaulageCharges['JobType'] ?
          this.jobTypeListMaster.getSelected(selectedHaulageCharges['JobType'], 'Job Type')
        : null;

      if (this.refList) {
        //to get the reference value from the refList to match when populating and extract the value from the list to get the exact value
        //turn it into an array and take the first element to get the keys
        //force uppercase to match the key refTitle returned from API call
        const refKey = Object.keys(this.refList[0]);
        const ele = refKey.find((e) => e.toUpperCase() === this.refTitle.toUpperCase());

        this.selectedRef =
          selectedHaulageCharges['ReferenceValue'] ?
            this.refList.getSelected(selectedHaulageCharges['ReferenceValue'], ele)
          : null;
      }

      if (selectedHaulageCharges['ValidFrom']) {
        const [day, month, year] = selectedHaulageCharges['ValidFrom'].split('/').map((datePart) => parseInt(datePart));
        this.validFromDate = new Date(year, month - 1, day);
      } else {
        this.validFromDate = null;
      }

      this.selectedRateType = this.rateTypes.find((ratetype) => ratetype.unit === selectedHaulageCharges['RateType']);
      this.container3 = null;
      this.container4 = null;
      this.selectedMarkupRateType = this.rateTypes.find(
        (ratetype) => ratetype.unit === selectedHaulageCharges['MarkUpRateType'],
      );
      if (this.selectedRateType.unit === '$') {
        this.rateFor20 = selectedHaulageCharges['RateFor20'];
        this.rateFor40 = selectedHaulageCharges['RateFor40'];
      }
      if (this.selectedRateType.unit === '%') {
        this.percentageFor20 = selectedHaulageCharges['RateFor20'];
        this.percentageFor40 = selectedHaulageCharges['RateFor40'];
        this.container1 = this.containers.find(
          (container) => container.value === selectedHaulageCharges['Rate20ofTariff'],
        );
        this.container2 = this.containers.find(
          (container) => container.value === selectedHaulageCharges['Rate40ofTariff'],
        );
      }
      if (this.selectedMarkupRateType.unit === '$') {
        this.markupRateFor20 = selectedHaulageCharges['MarkUpRate20'];
        this.markupRateFor40 = selectedHaulageCharges['MarkUpRate40'];
      }
      if (this.selectedMarkupRateType.unit === '%') {
        this.markupPercentageFor20 = selectedHaulageCharges['MarkUpRate20'];
        this.markupPercentageFor40 = selectedHaulageCharges['MarkUpRate40'];
        this.container3 = this.containers.find(
          (container) => container.value === selectedHaulageCharges['MarkUpRate20ofTariff'],
        );
        this.container4 = this.containers.find(
          (container) => container.value === selectedHaulageCharges['MarkUpRate40ofTariff'],
        );
      }
    },

    saveClicked: async function () {
      this.errorMessages = [];
      if (!this.checkfields()) {
        return;
      }
      this.requiredErrors = [];
      let ele = '';
      //similar to the populate get the exact value from the selected object using object.keys()
      //then match the key to the refTitle to get the exact value
      if (this.selectedRef && this.refTitle !== '') {
        const objkey = Object.keys(this.selectedRef);
        ele = objkey.find((e) => e.toUpperCase() === this.refTitle.toUpperCase());
        // ele = objkey[i];
      }

      const dataToPost = {
        action: this.popupEntryTitle[0],
        chgcode: this.selectedChargeCode ? this.selectedChargeCode['Charge Code'] : '',
        cunumber: this.selectedCustomerCode ? this.selectedCustomerCode['Customer Code'] : '',
        jobtype: this.selectedJobType ? this.selectedJobType['Job Type'] : '',
        shipperconsignee: this.selectedShipperConsingnee ? this.selectedShipperConsingnee['Customer Code'] : '',
        tariffarea: this.selectedTariffAreaCode ? this.selectedTariffAreaCode['Area Code'] : '',
        referencevalue: this.selectedRef ? this.selectedRef[ele] : '',
        ratetype: this.selectedRateType['unit'],
        markupratetype: this.selectedMarkupRateType['unit'],
        ratefor20: this.rateFor20 ? this.rateFor20 : this.percentageFor20,
        ratefor40: this.rateFor40 ? this.rateFor40 : this.percentageFor40,
        validfrom: this.validFromDate?.formatString('yyyy-MM-dd HH:mm:ss') ?? '',
        zonecategory: this.selectedZoneCategories?.map((obj) => obj['Zone Category']).join(',') ?? '',
        fieldhcharges: this.refTitle ?? '',
        tablehcharges: this.refTable ?? '',
        rate20oftariff: this.container1 ? this.container1.value : '',
        rate40oftariff: this.container2 ? this.container2.value : '',
        b2bcoefftype: this.selectedB2BCoefficient.label === 'Special' ? '1' : '0',
        b2bcoeff: this.b2bCoefficient.label === 'Use Standard' ? '' : this.b2bCoefficient,
        b2bcoeffoftariff: '',
        markuprate20: this.markupRateFor20 ? this.markupRateFor20 : this.markupPercentageFor20,
        markuprate40: this.markupRateFor40 ? this.markupRateFor40 : this.markupPercentageFor40,
        markuprate20oftariff: this.container3 ? this.container3.value : '',
        markuprate40oftariff: this.container4 ? this.container4.value : '',
        system: 'HMS',
        seqno: this.seqno,
        lastupdate: new Date().formatString('yyyy-MM-dd HH:mm:ss.sss'),
      };

      this.$fullscreenLoading('Updating Rates');
      const result = await this.$apiCallV2('/HaulageRate/UpdateRates', dataToPost);
      this.$fullscreenLoading();
      if (result[0].Results >= 1) {
        this.errorMessages.push(result[0].ErrMsg);
      } else {
        if (this.popupEntryTitle[0] === 'N' || this.popupEntryTitle[0] === 'E') {
          this.successMessages.push(result[0].ErrMsg);
        }
        this.viewMode = true;
        this.popupEntryTitle = 'View Haulage Rates';
        this.$nextTick(async () => await this.getListing());
      }
    },
    errorMessageClicked: function (item) {
      this.$nextTick(() => {
        this.$refs[item].setFocus();
      });
    },
    checkfields: function () {
      this.requiredErrors = [];
      if (!this.selectedChargeCode) {
        this.chargeCodeError = 'Charge Code is required.';
        this.requiredErrors.push({
          key: 'chargeCode',
          value: 'Charge Code is required',
        });
      }
      if (!this.selectedChargeCode && this.chargeCodeSearch !== '') {
        this.chargeCodeError = 'Invalid Charge Code';
        this.requiredErrors.push({
          key: 'chargeCode',
          value: 'Invalid Charge Code',
        });
      }
      if (this.validFromDate === null) {
        this.validFromDateError = 'Date is required';
        this.requiredErrors.push({
          key: 'validFrom',
          value: 'Date is required',
        });
      }

      if (this.compRefVal && this.refTitle !== '') {
        if (this.selectedRef === null) {
          this.refTypeError = `${this.refTitle} Reference is required`;
          this.requiredErrors.push({
            key: 'refType',
            value: `${this.refTitle} is required`,
          });
        }
      }

      if (this.selectedRateType.unit === '$') {
        if (this.rateFor20 === '') {
          this.rateFor20Error = 'Rate is required';
          this.requiredErrors.push({
            key: 'rateFor20',
            value: 'Rate is required',
          });
        }
        if (this.rateFor40 === '') {
          this.rateFor40Error = 'Rate is required';
          this.requiredErrors.push({
            key: 'rateFor40',
            value: 'Rate is required',
          });
        }
      } else if (this.selectedRateType.unit === '%') {
        if (this.percentageFor20 === '') {
          this.percentageFor20Error = 'Percentage is required';
          this.requiredErrors.push({
            key: 'percentageFor20',
            value: 'Percentage is required',
          });
        }
        if (this.percentageFor40 === '') {
          this.percentageFor40Error = 'Percentage is required';
          this.requiredErrors.push({
            key: 'percentageFor40',
            value: 'Percentage is required',
          });
        }
        if (!this.container1) {
          this.container1Error = 'Container is required';
          this.requiredErrors.push({
            key: 'container1',
            value: 'Container is required ',
          });
        }
        if (!this.container2) {
          this.container2Error = 'Container is required';
          this.requiredErrors.push({
            key: 'container2',
            value: 'Container is required',
          });
        }
      }
      if (this.selectedMarkupRateType.unit === '$') {
        if (this.markupRateFor20 === '') {
          this.markupRateFor20Error = 'Mark up rate is required';
          this.requiredErrors.push({
            key: 'markupRateFor20',
            value: 'Mark up rate is required',
          });
        }
        if (this.markupRateFor40 === '') {
          this.markupRateFor40Error = 'Mark up rate is required';
          this.requiredErrors.push({
            key: 'markupRateFor40',
            value: 'Mark up rate is required',
          });
        }
      } else if (this.selectedMarkupRateType.unit === '%') {
        if (this.markupPercentageFor20 === '') {
          this.markupPercentageFor20Error = 'Mark up percentage is required';
          this.requiredErrors.push({
            key: 'markupPercentageFor20',
            value: 'Mark up percentage is required',
          });
        }
        if (this.markupPercentageFor40 === '') {
          this.markupPercentageFor40Error = 'Mark up percentage is required';
          this.requiredErrors.push({
            key: 'markupPercentageFor40',
            value: 'Mark up percentage is required',
          });
        }
        if (!this.container3) {
          this.container3Error = 'Container is required';
          this.requiredErrors.push({
            key: 'container3',
            value: 'Container is required',
          });
        }
        if (!this.container4) {
          this.container4Error = 'Container is required';
          this.requiredErrors.push({
            key: 'container4',
            value: 'Container is required',
          });
        }
      }

      return this.requiredErrors.length == 0;
    },

    haulageRateB2BCoefCheck: async function () {
      this.$fullscreenLoading('Getting Charges Code Details ...');
      const result = await this.$apiCallV2('/HaulageRate/HaulageRateB2BCoefCheck', {
        chargecode: this.selectedChargeCode['Charge Code'],
      });
      this.showB2BCoef = result['Result']['showB2BCoef'] === '1';
      this.b2bCoefficient = result['Result']['defaultB2B'];
      this.showRef = result['Result']['showRef'] === '1';
      this.compRefVal = result['Result']['compRefVal'] === '1';
      this.refTitle = result['Result']['refTitle'];
      this.refTable = result['Result']['refTable'];
      this.refDesc = result['Result']['refDesc'];
      this.refList = result['Result']['RefList'];
      this.selectedRef = null;
      this.$fullscreenLoading();
    },
  },
  mounted() {
    this.$bus.$on('pageSASControlAccess', (x) => {
      if (x.page == 'Haulage Rates') {
        x.data.forEach((k) => {
          //key in menu same as control value from api
          const selectedMenu = this.menus.find((m) => m['key'] == k['Control']);
          if (selectedMenu) {
            selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
          }
        });
      }
    });

    let promisesFulfilled = 0;
    //array of promises that need to be resolved
    const mountedPromises = [
      this.getListing(),
      this.getChargeCodeListMaster(),
      this.getBillingCustomerCodeListMaster(),
      this.getShipperConsigneeListMaster(),
      this.getTariffAreaListMaster(),
      this.getZoneCategoryListMaster(),
      this.getJobType(),
    ];

    //map over the array to create a new array
    //increment the promisesFulfilled and update the loading indicator for each promise than already returned
    const promisesWithLoading = mountedPromises.map((promise) => {
      return promise.then(() => {
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      });
    });

    Promise.allSettled(promisesWithLoading).then(() => {
      this.menus = this.menus.map((menu) => ({
        ...menu,
        enabled: true,
      }));
    });
  },
  watch: {
    selectedRateType: {
      handler: function (newValue) {
        if (newValue) {
          if (newValue.description === 'Rate') {
            this.displayRate = true;
            this.displayPercentage = false;
            this.container1 = null;
            this.container2 = null;
            this.container1Search = '';
            this.container2Search = '';
            this.percentageFor20 = '';
            this.percentageFor40 = '';
          } else if (newValue.description === 'Percentage') {
            this.displayRate = false;
            this.displayPercentage = true;
            this.rateFor20 = '';
            this.rateFor40 = '';
          }
        }
      },
      immediate: true,
    },
    selectedMarkupRateType: {
      handler: function (newValue) {
        if (newValue) {
          if (newValue.description === 'Rate') {
            this.displayMarkupRate = true;
            this.displayMarkupPercentage = false;
            this.markupPercentageFor20 = '';
            this.markupPercentageFor40 = '';
            this.container3 = null;
            this.container4 = null;
            this.container3Search = '';
            this.container4Search = '';
          } else if (newValue.description === 'Percentage') {
            this.displayMarkupRate = false;
            this.displayMarkupPercentage = true;
            this.markupRateFor20 = '';
            this.markupRateFor40 = '';
          }
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.haulageCharges-main {
  font-size: 12px;
  width: 200px;
  height: 100%;
  padding: 10px 5px 10px 45px;
  display: flex;
  overflow: hidden;

  > .right-container {
    width: 100%;
    overflow: hidden;
    height: 100%;
    padding: 5px;
    border-radius: 5px;
    margin-left: 5px;
    background-color: white;
  }
}

.haulageCharges-main .input-query-width {
  width: 40%;
}

.tariffCode {
  display: flex;
  gap: 20px;
  align-items: center;
  margin-bottom: 5px;
  margin-top: -5px;
}

.B2BCoefficient {
  display: flex;
  align-items: center;
}
.displayPercentage {
  display: grid;
  grid-template-columns: 2fr 0.5fr 4fr;
  align-items: center;
}

p {
  margin: 0px;
}

.rightContainer {
  border-radius: 5px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin-right: 5px;

  > .bottomSection {
    width: 100%;
    height: calc(100% - 45px);
    border-radius: 5px;
    background-color: white;
    display: flex;
    margin-right: 5px;
    padding: 5px 15px 5px 5px;
    margin-left: 5px;
  }
}
</style>
